import Uuid from '../Uuid';
import { StadiumMaterialu } from './StadiumMaterialu';
import SablonaProcesu from '../ciselniky/SablonaProcesu';
import PolozkaCiselnik from '../ciselniky/PolozkaCiselnik';
import { Dolezitost } from '../pracovnyKrok/Dolezitost';
import { Kategoria } from '../pracovnyKrok/Kategoria';
import { SubjectItem } from './SubjectItem';
import Predkladatel from './Predkladatel';
import SuvisiaciProces from './SuvisiaciProces';
import Organizacia from '../ciselniky/Organizacia';
import PredpisZbierky from './PredpisZbierky';
import AktEuDetail from './AktEuDetail';

export const PREDBEZNA_INFORMACIA = '9fe9f993-e578-4a40-8a59-f444d5f827b7';
export const AKT_EU = 'fa06687b-821e-454a-9e14-45033c2fe636';

export default interface LegislativnyMaterialDetail {
  uuid: Uuid,
  cisloLegislativnehoMaterialu: string,
  nazov: string,
  poslednaZmena: Date,
  datumZaciatkuPkMpk?: Date,
  datumUkonceniaPkMpk?: Date,
  rezortneCislo?: string,
  podnet?: string,
  aktualnaPredkladatelskaInstitucia?: Organizacia,
  zodpovednaInstitucia?: Organizacia,
  aktualnyPredkladatel?: SubjectItem,
  zodpovednyPredkladatel?: SubjectItem,
  skrateneMpk: boolean,
  sledovany: boolean,
  sablonaProcesu: SablonaProcesu;
  suvisiaceProcesy?: Array<SuvisiaciProces>,
  dalsiPredkladatelia?: Array<Predkladatel>,
  hlavnyNovelizovanyPredpis?: PredpisZbierky,
  novelizovanePredpisy?: Array<PredpisZbierky>,
  typ: PolozkaCiselnik,
  stadium: StadiumMaterialu,
  oblastList?: Array<PolozkaCiselnik>,
  dovodSkratenehoMpk?: string,
  dovodZruseniaMpk?: string,
  vysledokNrSr?: string,
  dovodUkoncenia?: string,
  aktEu?: AktEuDetail,
  stupenDolezitostiAktu?: Dolezitost,
  gestor?: Organizacia,
  spolugestori?: Array<Organizacia>,
  dovodOdmietnutiaGestora?: string,
  kategoriaAktu?: Kategoria,
  namietkaKuGestorstvu?: string,
  vlastnikAktivity?: Organizacia,
  hasOpravneniePracovneKroky: boolean,
  hasOpravnenieSprievodneDokumenty?: boolean,
  hasPracovnyKrokInZasobnikPrace?: boolean,
  autorProcesu?: SubjectItem,
  camundaId?: string,
  dalsiPripomienkovatelia?: Array<Organizacia>,
  poradnyOrganVladyList?: Array<Organizacia>,
  vyhlasenyPodCislomList?: Array<PredpisZbierky>,
  datumVytvoreniaProcesu?: Date,
}
